import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@root/shared/service/translate.service';

type Type = 'none' | 'house' | 'room_type' | 'group';

@Component({
  selector: 'widget-rule-form-item-house-picker',
  templateUrl: './house-picker.component.html',
  styleUrls: ['./house-picker.component.scss'],
})
export class WidgetRuleHousePickerComponent implements OnInit {
  private readonly GroupListApi = '/api/house_group/group_list';
  _data: {
    type: Type;
    value: any;
  } = { type: 'none', value: [-1] };
  @Input()
  get data() {
    return this._data;
  }
  set data(data) {
    if (data?.type === 'group') {
      this._data = {
        type: 'group',
        value: data.value?.[0], // 服务端接受数组，前端组件单选接受的是一个值，所以需要转一下
      };
    } else {
      this._data = {
        type: data.type,
        value: data.value?.[0] === -1 ? null : data.value, // 服务端用-1作为不限的值，前端用null作为不限的值，因此必须转一下
      };
    }
  }
  @Input() showRoomTypeTip = true;
  @Output()
  onChange = new EventEmitter<{ type: Type; value: any }>();
  optionsOfGroupList: Option[] = [];
  constructor(private http: HttpClient, private t: TranslateService) {}

  ngOnInit() {
    this.initGroupOptions();
  }

  private initGroupOptions() {
    this.http.get(this.GroupListApi).subscribe((rst: any) => {
      this.optionsOfGroupList = rst?.data?.list?.map((item) => ({
        label: item.name,
        value: item.group_id,
      }));
      this.optionsOfGroupList.unshift({
        label: this.t.t('word.any'),
        value: -1,
      });
    });
  }

  onTypeChange(type) {
    let value;
    if (type === 'none') {
      value = [-1];
    } else if (type === 'group') {
      value = [-1];
    } else {
      value = null;
    }
    this.onChange.emit({
      type,
      value,
    });
  }

  onValueChange(value) {
    let result;
    if (!value) {
      result = [-1];
    } else if (Array.isArray(value)) {
      result = value;
    } else {
      result = [value];
    }
    this.onChange.emit({
      type: this.data.type,
      value: result,
    });
  }
}
